module.exports = __webpack_public_path__ + "img/design proposal_demo-04.e129e635.jpg";